import { Store } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, settings and first steps.
export const app: AppInfo = {
  key: "pos",
  icon: Store,
  tabs: [
    { to: "/pos", label: "nav.sell", perm: ["pos.sale.create"] },
    { to: "/pos/receipts", label: "nav.receipts", perm: ["pos.sale.read"] },
    { to: "/pos/shifts", label: "nav.shifts", perm: ["pos.session.read"] },
  ],
  settings: { to: "/settings/pos", perm: ["pos.register.create", "pos.register.update"] },
  setup: { register: "/settings/pos", sale: "/pos" },
};
